import { createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, vModelSelect as _vModelSelect, withModifiers as _withModifiers, createBlock as _createBlock, unref as _unref, createStaticVNode as _createStaticVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-3177a7bf"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "container" }
const _hoisted_2 = {
  key: 0,
  class: "simple-search-container"
}
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", null, "Search", -1))
const _hoisted_4 = { class: "input-container" }
const _hoisted_5 = {
  key: 1,
  class: "advanced-search-container"
}
const _hoisted_6 = { class: "advanced-search-title" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", null, "Advanced Search", -1))
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", null, "Search Within", -1))
const _hoisted_9 = { class: "flex-center vertical" }
const _hoisted_10 = ["onUpdate:modelValue"]
const _hoisted_11 = /*#__PURE__*/_createStaticVNode("<option value=\"name\" data-v-3177a7bf> Microgesture Name </option><option value=\"description\" data-v-3177a7bf> Microgesture Description </option><option value=\"mglyph\" data-v-3177a7bf> µGlyph </option><option value=\"paper_title\" data-v-3177a7bf> Paper Title </option><option value=\"doi\" data-v-3177a7bf> DOI </option><option value=\"grasp\" data-v-3177a7bf> Grasp </option><option value=\"object\" data-v-3177a7bf> Object </option>", 7)
const _hoisted_18 = [
  _hoisted_11
]
const _hoisted_19 = ["onUpdate:modelValue"]
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", null, "Search µGlyph", -1))
const _hoisted_21 = { class: "flex-center" }

import MicrogestureInput from '@/components/Microgesture/MicrogestureInput'
import { ref, watch } from 'vue'


export default {
  __name: 'SearchBar',
  props: ['microgestureSearchValue'],
  emits: ['search', 'reset'],
  setup(__props, { emit: emits }) {

const props = __props;




const isAdvanced = ref(false)
const searchValue = ref(null)
const searchWithinItems = ref([{ type: 'name', value: null }])
const reload = ref(0)

watch(
  props.microgestureSearchValue, () => {
    isAdvanced.value = true
    searchValue.value = props.microgestureSearchValue
    reload.value++
  }
)

function search () {
  const temp = []
  if (searchValue.value) {
    temp.push({ type: 'microgesture', value: searchValue.value })
  }
  if (isAdvanced.value) {
    for (const x of Object.values(searchWithinItems.value)) {
      if (x.value) temp.push(x)
    }
  } else {
    if (searchWithinItems.value[0]) temp.push(searchWithinItems.value[0])
  }
  emits('search', temp)
}

function reset () {
  searchValue.value = null
  searchWithinItems.value = [{ type: 'name', value: null }]
  emits('reset')
}

function addSearchWithinItem () {
  searchWithinItems.value.push({ type: 'name', value: null })
}

function removeSearchWithinItem (i) {
  searchWithinItems.value = searchWithinItems.value.filter((_, j) => j !== i)
}

return (_ctx, _cache) => {
  const _component_unicon = _resolveComponent("unicon")

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (!isAdvanced.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _hoisted_3,
          _createElementVNode("div", _hoisted_4, [
            _withDirectives(_createElementVNode("input", {
              "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => ((searchWithinItems.value[0].value) = $event)),
              placeholder: "Microgesture name"
            }, null, 512), [
              [_vModelText, searchWithinItems.value[0].value]
            ]),
            _createElementVNode("button", {
              class: "simple-search-button",
              onClick: search
            }, [
              _createVNode(_component_unicon, { name: "search" })
            ])
          ]),
          _createElementVNode("button", {
            class: "advance-button",
            onClick: _cache[1] || (_cache[1] = $event => (isAdvanced.value = true))
          }, "advanced")
        ]))
      : (_openBlock(), _createElementBlock("div", _hoisted_5, [
          _createElementVNode("div", _hoisted_6, [
            _hoisted_7,
            _createElementVNode("button", {
              class: "advance-button",
              onClick: _cache[2] || (_cache[2] = $event => (isAdvanced.value = false))
            }, "simple")
          ]),
          _hoisted_8,
          _createElementVNode("div", _hoisted_9, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(searchWithinItems.value.entries(), ([i,swi]) => {
              return (_openBlock(), _createElementBlock("div", {
                class: "search-within-row",
                key: `swi-${i}`
              }, [
                _withDirectives(_createElementVNode("select", {
                  "onUpdate:modelValue": $event => ((swi.type) = $event)
                }, _hoisted_18, 8, _hoisted_10), [
                  [_vModelSelect, swi.type]
                ]),
                _withDirectives(_createElementVNode("input", {
                  "onUpdate:modelValue": $event => ((swi.value) = $event),
                  placeholder: "Enter Search Term"
                }, null, 8, _hoisted_19), [
                  [_vModelText, swi.value]
                ]),
                _createVNode(_component_unicon, {
                  name: "plus-circle",
                  class: "advanced-plus-button",
                  onClick: _withModifiers(addSearchWithinItem, ["stop"])
                }, null, 8, ["onClick"]),
                (searchWithinItems.value.length > 1)
                  ? (_openBlock(), _createBlock(_component_unicon, {
                      key: 0,
                      name: "minus-circle",
                      class: "advanced-minus-button",
                      onClick: _withModifiers($event => (removeSearchWithinItem(i)), ["stop"])
                    }, null, 8, ["onClick"]))
                  : _createCommentVNode("", true)
              ]))
            }), 128))
          ]),
          _hoisted_20,
          _createElementVNode("div", _hoisted_21, [
            (_openBlock(), _createBlock(_unref(MicrogestureInput), {
              class: "microgesture-input-advanced",
              modelValue: searchValue.value,
              "onUpdate:modelValue": _cache[3] || (_cache[3] = $event => ((searchValue).value = $event)),
              key: `search-bar-input${reload.value}`
            }, null, 8, ["modelValue"]))
          ]),
          _createElementVNode("div", { class: "flex-center" }, [
            _createElementVNode("button", {
              class: "advanced-search-button",
              onClick: search
            }, "Search"),
            _createElementVNode("button", {
              class: "advanced-search-button",
              onClick: reset
            }, "Reset")
          ])
        ]))
  ]))
}
}

}